export const formatToGermanPrice = (input: number) => {
  if (!input) {
    return input;
  }

  return input.toLocaleString("de-DE", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};
